import { plural, t } from '@lingui/macro'

function formatUpcomingDaysDifference(days: number) {
  if (days === 0) {
    return t({
      id: 'globals.today',
      message: 'Vandaag',
    })
  } else if (days === 1) {
    return t({
      id: 'globals.tomorrow',
      message: 'Morgen',
    })
  } else if (days > 14) {
    const numberWeeks = Math.floor(days / 7)
    return t({
      id: 'globals.week',
      comment: 'week(s)',
      message: plural(numberWeeks, {
        one: `Over ${numberWeeks} week`,
        other: `Over ${numberWeeks} weken`,
      }),
    })
  } else {
    return t({
      id: 'globals.day',
      comment: 'day(s)',
      message: plural(days, {
        one: `Over ${days} dag`,
        other: `Over ${days} dagen`,
      }),
    })
  }
}

function formatToWaitTime(waitTime: number) {
  if (waitTime && waitTime > 0) {
    const waitTimeHours = Math.floor(waitTime / 60)
    const waitTimeMinutes = waitTime % 60

    return `+${
      waitTimeHours > 0
        ? `${waitTimeHours} ${t({
            id: 'globals.hour.short',
            comment: 'shorthand for hours',
            message: 'u',
          })} `
        : ''
    }${
      waitTimeMinutes > 0
        ? `${waitTimeMinutes} ${t({
            id: 'globals.minutes.short',
            comment: 'shorthand for minutes',
            message: 'min',
          })}`
        : ''
    }`
  }
  return null
}

export { formatToWaitTime, formatUpcomingDaysDifference }
